import type { i18n as I18n } from "i18next";
import en from "@/locales/en/games/klondike.json";
import fr from "@/locales/fr/games/klondike.json";

export const KLONDIKE_NS = "games/klondike";

/** Adds this game's translations to an initialised i18next instance (idempotent). */
export function registerKlondikeTranslations(i18n: I18n): void {
  if (!i18n.hasResourceBundle("en", KLONDIKE_NS))
    i18n.addResourceBundle("en", KLONDIKE_NS, en, true, true);
  if (!i18n.hasResourceBundle("fr", KLONDIKE_NS))
    i18n.addResourceBundle("fr", KLONDIKE_NS, fr, true, true);
}
